export default __webpack_public_path__ + "static/media/cif-hn.031ac138.svg";